import styled from '@emotion/styled';
import { rem } from '@utils';

const InsightText = styled.div`
  color: ${({ theme }) => theme.palette.grey['500']};
  font-size: ${rem(14)};
  line-height: ${rem(16)};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  width: 100%;

  && :is(h1, h2, h3, h4, h5, h6), && :is(p) {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
`;

const Title = styled.h4`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(16)};
  font-weight: ${({ theme }) => theme.typography.fontWeightSemiBold};
  line-height: ${rem(24)};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default {
  Wrapper,
  InsightText,
  Title
};
